export default __webpack_public_path__ + "static/media/Settings.38abbf30.svg";